import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../Services/order.service';
import Swal from 'sweetalert2';
import { IMyDayLabels, IMyDpOptions, IMyMarkedDate } from 'mydatepicker';
import { saveAs } from 'file-saver';
import { Response } from '@angular/http';
import { StockService } from '../../Services/stock.service';
import { ClothesService } from '../../Services/clothes.service';
import { AuthService } from '../../Services/auth.service';
import { timeout } from 'rxjs/operator/timeout';



@Component({
  selector: 'app-order-list',
  template: require('./order-list.component.html'),
  styles: [require('./order-list.component.css')]
})
export class OrderListComponent implements OnInit {

  constructor(private orderService: OrderService, private stockService:StockService,private clothesService: ClothesService, private auth: AuthService) { }
  
  StockOrderId=-1;
  all_orders: any[] = [];
  orders_by_members: any = {};
  totals_by_members: any = {};
  memberKeys: any[] =[];
  searchString: string = '';
  
  selectedCartItems: any = [];
  listLayout: boolean = false;

  beginDate: any;
  endDate: any;
  isOpen: boolean = false;
  orderTitle: string = ""
  all_clothesSizes: any[] = [];
  edit_cartItem:any={
    clothes:{
      image:"",
    }
  }
  

  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
  };


  ngOnInit() {
   this.loadOrders();
   this.getStockOrderId();
   this.loadAllClothesSizes();
  }

  loadOrders(){
     this.orderService.getAllOrders(true).subscribe( (res:any) => {
        this.all_orders = res;
    })
  }

  getStockOrderId(){
    this.stockService.getStockOrderId().subscribe ( (res:any)=> {
      if (res.status == 200){
        this.StockOrderId = res.value
      }
    })
  }

  closeOrder(id: number){
    let order = this.all_orders.find( o => o.id == id)
    this.orderService.changeOrderStatus(id, !order.orderOpen).subscribe ( res =>{
      if (res.status == 200){
        order.orderOpen = res.value.orderOpen
      }
      
    })
    
  }

  getCartItems(id: number){
    this.selectedCartItems = []
    this.orderService.getAllCartItems(id).subscribe ( (res:any)=> {
      this.orders_by_members = {};
      this.totals_by_members = {};
      var  processed_cartIds:string[] = [];

      res.forEach( (element:any) => {
        let memberName = element.member.firstName +" "+element.member.lastName
        if (!this.orders_by_members.hasOwnProperty(memberName)){
          this.orders_by_members[memberName] = {}
          this.memberKeys.push(memberName);
        }
        if (!this.orders_by_members[memberName].hasOwnProperty(element.cartId)){
          this.orders_by_members[memberName][element.cartId] = [];
          this.orders_by_members[memberName][element.cartId]['orgObject'] = [];
          this.orders_by_members[memberName][element.cartId]['amount'] = 0;
          this.orders_by_members[memberName][element.cartId]['name'] = memberName;
          this.orders_by_members[memberName][element.cartId]['price'] = 0;
          this.orders_by_members[memberName][element.cartId]['discount'] = 0;
          this.orders_by_members[memberName][element.cartId]['cartId'] = element.cartId;
          this.orders_by_members[memberName][element.cartId]['payed'] = element.payed;
          this.orders_by_members[memberName][element.cartId]['memberId'] = element.memberId;
        }
        if (!this.totals_by_members.hasOwnProperty(memberName)){
            this.totals_by_members[memberName] = {}
            this.totals_by_members[memberName]['totalAmount'] = 0;
            this.totals_by_members[memberName]['totalPrice']  = 0;
            this.totals_by_members[memberName]['totalDiscount'] = 0;
            // this.totals_by_members[memberName]['payedPrice']  = 0;
        }

        this.orders_by_members[memberName][element.cartId]['orgObject'].push(element);
        this.orders_by_members[memberName][element.cartId]['amount'] += element.amount;
        this.orders_by_members[memberName][element.cartId]['discount'] = element.discountReceivedForCartId;
        var p = element.amount * element.clothes.price;
        this.orders_by_members[memberName][element.cartId]['price'] += p;

        this.totals_by_members[memberName]['totalAmount'] += element.amount ;
        this.totals_by_members[memberName]['totalPrice'] += p;

        if (! processed_cartIds.includes(element.cartId)){
          this.totals_by_members[memberName]['totalDiscount'] +=  element.discountReceivedForCartId ;
          processed_cartIds.push(element.cartId)
        }
        this.totals_by_members[memberName]['totalPayed'] =  this.totals_by_members[memberName]['totalPrice'] - this.totals_by_members[memberName]['totalDiscount']  ;

      });

      this.memberKeys = Object.keys(this.orders_by_members).sort(
        function (a, b) {
          var nameA = a.toLowerCase(), nameB = b.toLowerCase();
          if (nameA < nameB) //sort string ascending
            return -1;
          if (nameA > nameB)
            return 1;
          return 0; //default return value (no sorting)

        });

    })
    
  }

  getCartIds(memberid: string){
    return Object.keys(this.orders_by_members[memberid])
  }


  removeItemFromCart(id:string){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
        if (result.value) {
          this.orderService.deleteCartByID(id).subscribe( (x:any)=>{
            this.loadOrders()
          })
        };
      });
  }

  editCartItems(id: number){
    this.orderService.getCartItemsById(id).subscribe( (res:any)=>{
      if (res.status == 200){
        this.edit_cartItem = res.value[0];
      }
    })
  }

  getClothesSizesForId(id:number, clothesID:boolean = true ):any[] {
    if (clothesID){
      return this.all_clothesSizes.filter( cs => {
        return cs.clothesId === id
      })
    }else{
      return this.all_clothesSizes.filter( cs => {
        return cs.id === id
      })
    }
  }
  loadAllClothesSizes(){
    this.clothesService.getClothesAllSizes().subscribe( x=>{
      this.all_clothesSizes = x;
    })
}
  OnPaymentChange(member: string, cartId: string){   
    this.orderService.updatePayed(this.orders_by_members[member][cartId]['memberId'], cartId, this.orders_by_members[member][cartId]['payed']).subscribe( (res:any)=>{
      if (res.status == 200){
          let order =  this.all_orders.find( o => o.id == res.value.orderId);
          let amount = this.orders_by_members[member][cartId]['price']
          if (res.value.payed){
            order.totalPayed += amount
          }else if (!res.value.payed){
            order.totalPayed -= amount
          }
      }
    })
  }

  viewCartItems(memberId: string,cartId: string){
    this.selectedCartItems = this.orders_by_members[memberId][cartId]['orgObject'];
    this.selectedCartItems.name = memberId;
    this.calculateDetailItems();
  }

  viewCombinedCartItems(memberId:string){
    this.selectedCartItems = [];
    let k = Object.keys(this.orders_by_members[memberId]);
    k.forEach( (i:any) => {
      this.selectedCartItems = this.selectedCartItems.concat(this.orders_by_members[memberId][i]['orgObject'])
    });
    this.selectedCartItems.name = memberId + " (totaal)";
    this.calculateDetailItems();
  }

  calculateDetailItems(){
    var totalItems = 0;
    this.selectedCartItems.forEach((element:any) => {
      totalItems += element.amount
    });

    this.selectedCartItems['totalItems']=totalItems;
  }

  closeDetailView(){
    this.selectedCartItems = [];
  }
  
  CalculateTotalsOverview(orderid: number){
    this.selectedCartItems = [];
    this.orderService.getOrderOverview(orderid).subscribe (  (res:any)=>{
      if (res.status == 200){
        var totalItems:number = 0;
        res.value.forEach( (l:any) => {
          var i = {
              amount: l.amount, 
              size: l.size,
              totalItems:0,
             
              clothes:{
                  title: l.title, 
                  isMale: l.isMale,
                  isFemale:l.isFemale 
              }
          }
          this.selectedCartItems.push(i);
          totalItems += l.amount;
        });
        this.selectedCartItems.totalItems=totalItems;
        this.selectedCartItems.name = "Totale bestelling"
        this.selectedCartItems.orderid= orderid;
      }
    })
  }


  createNewOrder(){
    var beginDate = String(this.beginDate.date.year)+"-"+String(this.beginDate.date.month)+"-"+String(this.beginDate.date.day)
    var endDate = String(this.endDate.date.year)+"-"+String(this.endDate.date.month)+"-"+String(this.endDate.date.day)

    var neworder = {
                    "name":this.orderTitle,
                    "openedOn": beginDate,
                    "closedOn": endDate,
                    "orderOpen": this.isOpen
                  }
    this.orderService.startNewOrder(neworder).subscribe ( res => {
      this.loadOrders();
    })
    
  }
 
  DownloadOrder(id:number){ 
    Swal.fire({
      title: 'Welke lijst wil je downloaden?',
      // text: "Kies de lijst die je wil gebruiken om de bestelling klaar te maken?",
      input: "select",
      inputOptions: {
        "allTable": "Alle kledij per lid (Tabel)",
        "gentsTable":"Mannen kledij per lid (Tabel)",
        "galsTable":"Vrouwen kledij per lid (Tabel)",
        
        "Empty1":"",
        
        "allSheet": "Alle kledij per lid (Sheet)",
        "gentsSheet":"Mannen kledij per lid (Sheet)",
        "galsSheet":"Vrouwen kledij per lid (Sheet)",
        
        "Empty2":"",
        
        "OverviewAll": "Overzicht alle kledij (leverancier) ",
        "OverviewGents":"Overzicht alle mannen kledij (leverancier)",
        "OverviewGals":"Overzicht alle vrouwen kledij (leverancier)",
        
        "Empty3":"",
        
        "list": "Lijst van alle aantallen per lid",

        "VermarcItemList": "Lijst van alle bestelde kledij in formaat Vermarc",
      },
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Annuleer'
    }).then((result) => {
      if (result.value) {
        switch (result.value){
          case "allTable":
            this.DownloadOrderPerMember(id, "all");
            break;
          case "gentsTable":
            this.DownloadOrderPerMember(id, "gents");
            break;
          case "galsTable":
            this.DownloadOrderPerMember(id, "gals");
            break;
          case "allSheet":
            this.DownloadOrderPerMemberSheet(id, "all");
            break;
          case "gentsSheet":
            this.DownloadOrderPerMemberSheet(id, "gents");
            break;
          case "galsSheet":
            this.DownloadOrderPerMemberSheet(id, "gals");
            break;
          case "list":
            this.DownloadOrderList(id);
            break;
          case "OverviewAll":
            this.DownloadOverViewVendor(id, "all");
            break;
          case "OverviewGents":
            this.DownloadOverViewVendor(id, "gents");
            break;
          case "OverviewGals":
            this.DownloadOverViewVendor(id, "gals");
            break;
          case "VermarcItemList":
            this.DownloadOrderListVermarc(id);
            break;
        }
       
      }
    });
  }


  DownloadOrderOverview(id:number){ 
    Swal.fire({
      title: 'Welke lijst wil je downloaden?',
      // text: "Kies de lijst die je wil gebruiken om de bestelling klaar te maken?",
      input: "select",
      inputOptions: {
        "all": "Overzicht alle kledij ",
        "gents":"Overzicht alle mannen kledij ",
        "gals":"Overzicht alle vrouwen kledij",
        // "bestelling": "Aantal items/maat/soort"
      },
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Annuleer'
    }).then((result) => {
      if (result.value) {
        this.DownloadOverViewVendor(id, result.value);
      }
    });

  }

  amountChangedEditCartItem(amount:number){
    this.edit_cartItem.amount = amount    
  }
  
  sizeChangedEditCartItem(sizeId: string){
    this.edit_cartItem.size= (this.getClothesSizesForId(parseInt(sizeId), false)[0]).size
    this.edit_cartItem.sizeId = sizeId;  
  }

  ChangeCartItem(){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit item wil wijzigen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        var item = {
          ItemId: this.edit_cartItem.id,
          Amount: this.edit_cartItem.amount,
          Size: this.edit_cartItem.size,
          CartItemId: this.edit_cartItem.id
        }

        var order = {
          items: [item],
          memberId: this.edit_cartItem.memberId
        }
        
        this.orderService.changCartItem(order).subscribe( (res:any) =>{
          if (res.status == 200){
            var item = res.value
            this.getCartItems(item.orderId);
            setTimeout( ()=>{
              var id = item.firstName +" "+item.lastName
              this.viewCartItems(id, item.cartId)
            } ,1000)
            
          }
        });
      }
    });
  }

  deleteEditCartItem(){
     Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit item wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        var item = {
          ItemId: this.edit_cartItem.id,
          Amount: 0,
          Size: this.edit_cartItem.size,
          CartItemId: this.edit_cartItem.id
        }

        var order = {
          items: [item],
          memberId: this.edit_cartItem.memberId
        }
        
        this.orderService.changCartItem(order).subscribe( (res:any) =>{
          if (res.status == 200){
            var item = res.value
            this.getCartItems(item.orderId);
            setTimeout( ()=>{
              var id = item.firstName +" "+item.lastName
              if (this.orders_by_members.hasOwnProperty(id)){
                  this.viewCartItems(id, item.cartId)
              }
            } ,1000)           
          }
        });
      }
    });
  }
  
  private DownloadOrderPerMember(id:number, result: string){
      this.orderService.downloadOrderPerMembersXlsx(id, result).subscribe((res: Response) => {
        if (res.headers) {
          if (res.headers) {
            var header = "";
            header = res.headers.get('content-disposition') || "";
            var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
            var endIndex = header.indexOf(";", startIndex);
            var filename = header.substring(startIndex, endIndex);
            saveAs(res.blob(), filename);
          }
        }
       });
  }


  private DownloadOrderPerMemberSheet(id:number, result: string){
    this.orderService.downloadOrderPerMembersXlsxSheet(id, result).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          saveAs(res.blob(), filename);
        }
      }
     });
}

  private DownloadOrderList(id:number){ 
          this.orderService.downloadOrderListXlsx(id).subscribe((res: Response) => {
            if (res.headers) {
              if (res.headers) {
                var header = "";
                header = res.headers.get('content-disposition') || "";
                var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
                var endIndex = header.indexOf(";", startIndex);
                var filename = header.substring(startIndex, endIndex);
                saveAs(res.blob(), filename);
              }
            }
        });
  }
  
  private DownloadOverViewVendor(id: number, result:string){
    this.orderService.downloadOrderOverviewXlsx(id, result).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  private DownloadOrderListVermarc(id: number){
    this.orderService.downloadVermarcItemListXlsx(id).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          saveAs(res.blob(), filename);
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/order-list/order-list.component.ts